class Api {
  constructor() {
    this.Widget = null
    this.TvKey = null
    this.Plugin = null
  }

  _init = async () => {
    await this.loadResources()
    await _$.sleep(2000)
    await this.makeConfigurations()

    this.addListeners()

    return true
  }

  addListeners = () => {
    curWidget.onWidgetEvent = event => _$.handler.emit(event)

    _$.vue.$on("mediaPlaying", () => !__.device.isPowerOn() && __.media.stop().then(() => __.media.request(true)))

    _$.vue.$on("standBy", () => __.platform.go().then(() => __.media.request(true)))
    _$.vue.$on("powerOn", () => __.media.request())

    return true
  }
  makeConfigurations = async () => {
    this.Widget = new Common.API.Widget()
    this.TvKey = new Common.API.TVKeyValue()
    this.Plugin = new Common.API.Plugin()

    return true
  }
  loadResources = async () => {
    _$.loader.createScript({
      type: "text/javascript",
      language: "javascript",
      src: "$MANAGER_WIDGET/Common/Plugin/Define.js"
    })
    _$.loader.createScript({
      type: "text/javascript",
      language: "javascript",
      src: "$MANAGER_WIDGET/Common/API/Plugin.js"
    })
    _$.loader.createScript({
      type: "text/javascript",
      language: "javascript",
      src: "$MANAGER_WIDGET/Common/API/TVKeyValue.js"
    })
    _$.loader.createScript({
      type: "text/javascript",
      language: "javascript",
      src: "$MANAGER_WIDGET/Common/API/Widget.js"
    })

    _$.loader.createObject("object", {
      id: "pluginEvent",
      classid: "clsid:SAMSUNG-INFOLINK-SEF",
      class: "plugin",
      style: "position:absolute;opacity: 0.0; background-color: #000; width: 0px; height: 0px;"
    })

    _$.loader.createObject("object", {
      id: "pluginTV",
      classid: "clsid:SAMSUNG-INFOLINK-SEF",
      class: "plugin",
      style: "position:absolute;opacity: 0.0; background-color: #000; width: 0px; height: 0px;"
    })

    _$.loader.createObject("object", {
      id: "pluginNavi",
      classid: "clsid:SAMSUNG-INFOLINK-NNAVI",
      class: "plugin",
      style: "position:absolute;opacity: 0.0; background-color: #000; width: 0px; height: 0px;"
    })

    _$.loader.createObject("object", {
      id: "pluginObjectTVMW",
      classid: "clsid:SAMSUNG-INFOLINK-TVMW",
      class: "plugin",
      style: "position:absolute;opacity: 0.0; background-color: #000; width: 0px; height: 0px;"
    })

    _$.loader.createObject("object", {
      id: "pluginObjectCommon",
      classid: "clsid:SAMSUNG-INFOLINK-APPCOMMON",
      class: "plugin",
      style: "position:absolute;opacity: 0.0; background-color: #000; width: 0px; height: 0px;"
    })
  }
  checkOut() {
    _$.sleep(3000).then(() => __.device.reboot())
  }
}

export default Api
